import { FC } from "react";
import { ForgotPassword } from "../../../../modules/authentication/forgot-password/forgot-password";

export const ForgotPasswordRoute: FC = () => {
    return (
        <ForgotPassword />
    )
}